import { vec2, glMatrix } from "gl-matrix";

glMatrix.setMatrixArrayType(Array);
class CollisionTester {
  /**
   * Uses Separating Axis Theorem to determine if the selection rectangle
   * actually intersects a display object.
   * @return boolean if rectB collides with rectA
   */
  static isColliding(/** Rectangle **/ rectA, /** Rectangle **/ rectB) {
    //Calculate the axes that will be used in checking for collision
    let axes = [];

    axes.push(vec2.subtract(vec2.create(), rectA.tr, rectA.tl));
    axes.push(vec2.subtract(vec2.create(), rectA.bl, rectA.tl));
    axes.push(vec2.subtract(vec2.create(), rectB.tr, rectB.tl));
    axes.push(vec2.subtract(vec2.create(), rectB.bl, rectB.tl));

    let collision = true;

    for (let i = 0; i < axes.length && collision; i++) {
      let aMinMax = CollisionTester.getMinMaxScalarValue(rectA, axes[i]);
      let bMinMax = CollisionTester.getMinMaxScalarValue(rectB, axes[i]);

      if (bMinMax.min > aMinMax.max || bMinMax.max < aMinMax.min) {
        collision = false;
      }
    }

    return collision;
  }

  static getMinMaxScalarValue(/** Rectangle **/ rect, axis) {
    let pTLVal = vec2.dot(rect.tl, axis);
    let pTRVal = vec2.dot(rect.tr, axis);
    let pBLVal = vec2.dot(rect.bl, axis);
    let pBRVal = vec2.dot(rect.br, axis);

    let minMax = {
      min: Math.min(pTLVal, pTRVal, pBLVal, pBRVal),
      max: Math.max(pTLVal, pTRVal, pBLVal, pBRVal),
    };

    return minMax;
  }
}

export default CollisionTester;
